import { ReactElement } from 'react';
import { Advisor } from '@minutes-system/backend/src/api/advisors/schema';
import { Customer } from '@minutes-system/backend/src/api/customers/schema';
import { UpdateRecordingBody } from '@minutes-system/backend/src/api/recordings/schema';
import RecordingInfo from './RecordingInfo';
import RecordingData from './RecordingData';
import AudioSection from './AudioSection';
import Summary from './Summary';
import { RecordingOverviewBlock } from './RecordingOverview.style';
import { UseAudioPlayerReturn } from '../../hooks/useAudioPlayer';

interface Props {
  title: string;
  advisor: { id: number; name: string; phone: string | null } | null;
  customer: { id: number; name: string; phone: string | null; mobilePhone: string | null } | null;
  meetingDateTime: Date;
  advisors: Advisor[];
  customers: Customer[];
  advisorPhone: string | null;
  customerPhone: string | null;
  originalFrom: string | null;
  originalTo: string | null;
  duration: number | null;
  registeredAt: Date;
  isAudioAvailable: boolean;
  audioPlayer: UseAudioPlayerReturn;
  summaryText: string | null;
  recordingStatusId: number;
  onUpdateRecording: (data: UpdateRecordingBody) => Promise<{ success: boolean }>;
  onUpdateSummary: (summaryText: string) => Promise<{ success: boolean }>;
}

const RecordingOverview = ({
  title,
  advisor,
  customer,
  meetingDateTime,
  advisors,
  customers,
  advisorPhone,
  customerPhone,
  originalFrom,
  originalTo,
  duration,
  registeredAt,
  isAudioAvailable,
  audioPlayer,
  summaryText,
  recordingStatusId,
  onUpdateRecording,
  onUpdateSummary,
}: Props): ReactElement => {
  return (
    <RecordingOverviewBlock>
      <RecordingInfo
        title={title}
        advisor={advisor}
        customer={customer}
        meetingDateTime={meetingDateTime}
        advisors={advisors}
        customers={customers}
        advisorPhone={advisorPhone}
        customerPhone={customerPhone}
        originalFrom={originalFrom}
        originalTo={originalTo}
        recordingStatusId={recordingStatusId}
        onUpdate={onUpdateRecording}
      />
      <RecordingData duration={duration} registeredAt={registeredAt} />
      <AudioSection duration={duration} isAudioAvailable={isAudioAvailable} audioPlayer={audioPlayer} />
      <Summary summaryText={summaryText} recordingStatusId={recordingStatusId} onUpdate={onUpdateSummary} />
    </RecordingOverviewBlock>
  );
};

export default RecordingOverview;
